import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "my-3" }
const _hoisted_2 = { class: "my-3" }
const _hoisted_3 = { class: "my-3" }
const _hoisted_4 = { class: "my-3" }
const _hoisted_5 = { class: "my-3" }
const _hoisted_6 = {
  key: 0,
  class: "my-3"
}
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = {
  key: 1,
  class: "my-3"
}
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "my-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "primary",
        flat: "",
        app: "",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_app_bar_title, { style: {"min-width":"fit-content"} }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("アルバム一覧", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "pa-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    block: "",
                    variant: "text",
                    color: "primary",
                    size: "large",
                    onClick: _cache[0] || (_cache[0] = () => _ctx.isCreateDialogOpen = true)
                  }, {
                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                      _createTextVNode("+ アルバムを追加する", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.isFetching)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    height: "3"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_tabs, {
                "fixed-tabs": "",
                modelValue: _ctx.listType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listType) = $event)),
                color: "primary",
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, null, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                      _createTextVNode("すべて", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, null, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("公開中", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, null, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode("非公開中", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums, (album) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: album.albumId
                  }, [
                    _createVNode(_component_v_list_item, {
                      to: `/album/${album.albumId}`,
                      style: {"margin":"8px"}
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createTextVNode("mdi-chevron-right", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(album.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createVNode(_component_v_divider)
                  ], 64))
                }), 128))
              ]),
              (_ctx.hasMoreAlbums)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 1,
                    class: "my-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        text: "",
                        color: "primary",
                        large: "",
                        onClick: _ctx.loadMore
                      }, {
                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                          _createTextVNode("さらに読み込む", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.isCreateDialogOpen,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isCreateDialogOpen) = $event)),
        "max-width": "720"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "align-center justify-center" }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode(" アルバムを作成 ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "mb-2" }, "年度", -1)),
                    _createVNode(_component_v_text_field, {
                      type: "number",
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined",
                      modelValue: _ctx.newAlbumYear,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newAlbumYear) = $event)),
                      color: "primary",
                      disabled: _ctx.newAlbumClassIds && _ctx.newAlbumClassIds.length > 0
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "mb-2" }, "クラス", -1)),
                    _createVNode(_component_v_select, {
                      variant: "outlined",
                      multiple: "",
                      density: "compact",
                      "hide-details": "",
                      modelValue: _ctx.newAlbumClassIds,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newAlbumClassIds) = $event)),
                      items: _ctx.classes,
                      "item-value": "classId",
                      "item-title": "className",
                      color: "primary"
                    }, null, 8, ["modelValue", "items"])
                  ]),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "mb-2" }, "アルバムのタイトル", -1)),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined",
                      modelValue: _ctx.newAlbumTitle,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newAlbumTitle) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "mb-2" }, "コメント", -1)),
                    _createVNode(_component_v_text_field, {
                      density: "compact",
                      "hide-details": "",
                      variant: "outlined",
                      modelValue: _ctx.newAlbumComment,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newAlbumComment) = $event)),
                      color: "primary"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_v_radio_group, {
                      modelValue: _ctx.albumType,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.albumType) = $event)),
                      inline: "",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                          label: "日常",
                          value: "ordinary"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "行事",
                          value: "event"
                        }),
                        _createVNode(_component_v_radio, {
                          label: "その他",
                          value: "undefined"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.albumType === 'ordinary' || _ctx.albumType === 'event')
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_select, {
                              modelValue: _ctx.selectedMonth,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                              items: _ctx.monthItems,
                              "item-title": "title",
                              "item-value": "value",
                              label: "月を選択",
                              "hide-details": "",
                              variant: "outlined",
                              density: "compact",
                              color: "primary"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.isCreateInClosed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "mb-2" }, "公開開始日 *", -1)),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_checkbox, {
                            label: `すぐに公開`,
                            modelValue: _ctx.isPublishNow,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isPublishNow) = $event)),
                            color: "primary",
                            disabled: _ctx.albumType === 'ordinary' || _ctx.albumType === 'event'
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        (!_ctx.isPublishNow)
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              type: "datetime-local",
                              density: "compact",
                              "hide-details": "",
                              variant: "outlined",
                              modelValue: _ctx.newAlbumAvailableAfter,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newAlbumAvailableAfter) = $event)),
                              color: "primary",
                              disabled: _ctx.albumType === 'ordinary' || _ctx.albumType === 'event'
                            }, null, 8, ["modelValue", "disabled"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.isCreateInClosed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[28] || (_cache[28] = _createElementVNode("span", { class: "mb-2" }, "公開終了日", -1)),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_checkbox, {
                            label: `制限なし`,
                            modelValue: _ctx.isPublicForever,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.isPublicForever) = $event)),
                            color: "primary",
                            disabled: _ctx.albumType === 'ordinary' || _ctx.albumType === 'event'
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        (!_ctx.isPublicForever)
                          ? (_openBlock(), _createBlock(_component_v_text_field, {
                              key: 0,
                              type: "datetime-local",
                              density: "compact",
                              "hide-details": "",
                              variant: "outlined",
                              modelValue: _ctx.newAlbumAvailableBefore,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newAlbumAvailableBefore) = $event)),
                              color: "primary",
                              disabled: _ctx.albumType === 'ordinary' || _ctx.albumType === 'event'
                            }, null, 8, ["modelValue", "disabled"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_checkbox, {
                      label: `非公開で作成する`,
                      modelValue: _ctx.isCreateInClosed,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isCreateInClosed) = $event)),
                      color: "primary",
                      disabled: _ctx.albumType === 'ordinary' || _ctx.albumType === 'event'
                    }, null, 8, ["modelValue", "disabled"])
                  ])
                ]),
                _: 1
              }),
              (_ctx.isCreating)
                ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                    key: 0,
                    indeterminate: "",
                    color: "primary",
                    height: "3"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    onClick: _cache[13] || (_cache[13] = () => _ctx.isCreateDialogOpen = false)
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    disabled: _ctx.isCreating || !_ctx.availableAfterValue || !_ctx.newAlbumTitle,
                    onClick: _ctx.create,
                    variant: "flat"
                  }, {
                    default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                      _createTextVNode(" 作成 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}